import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	admin: {
		auth: null,
		dashboard: null,
		admins: null,
		users: null,
		issuance: {
			list: null,
			add: null
		},
		logout: null
	}
});
